export default __webpack_public_path__ + "static/media/pulse-negative.8c212937.svg";